<template>
  <div class="sem618-box-h5">
    <!-- 头部导航 -->
    <Header type="h5" />
    <!-- Banner -->
    <Banner
      :isPcFlag="false"
      h5Title=""
      h5TitleSecond=" "
      h5Desc=""
      :h5BgImg="h5BgImg"
      h5signetBtn="免费试用"
      class="h5-sem618-banner"
      @showSignetDialog="showDialog"
      :landingPageName="landingPageName"
    />
    <!-- 618专享权益 -->
    <div class="sem618-equity">
      <div class="title">{{ equityData.title }}</div>
      <div class="desc">{{ equityData.desc }}</div>
      <div class="info">
        <div class="item" v-for="(item, index) in equityData.equityList" :key="index">
          <div class="sub-title">{{ item.subTitle }}</div>
          <div class="msg">
            <span v-for="(msg, index) in item.msg" :key="index" :class="{ 'blod-msg': msg === item.bold }">{{ msg }}</span>
            <img :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 灵活产品与能力 -->
    <ProductPower class="product-power" @showDialog="showDialog" :title="productPower.title" :powerList="productPower.powerList" />
    <!-- 无需邮寄，1分钟完成线上签署 -->
    <div class="flow-path">
      <SectionCard :isPcFlag="false" title="无需邮寄，1分钟完成线上签署" :bgImg="flowPathBg">
        <div class="path-content">
          <div class="content">
            <div class="path-left">
              <div class="one-line">
                <div class="item" v-for="item in flowPathOneLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="one-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
              <div class="two-line">
                <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
              </div>
              <div class="three-line">
                <div class="item" v-for="item in flowPathTwoLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="three-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 安全可靠的电子签章服务 -->
    <div class="safe-reliable">
      <SectionCard :isPcFlag="false" title="安全可靠的电子签章服务">
        <div class="content">
          <div class="card" v-for="(item, index) in safeReliableData" :key="index">
            <img :src="item.h5img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 销售热线 -->
    <div class="sales-hotline">
      <a class="title" href="tel:0571-85785223">销售热线：0571-85785223</a>
      <div class="zxzx" @click="showDialog">免费试用</div>
    </div>
    <div class="footer-btns">
      <div class="item" @click="OnlineConsultationClick">
        <img src="@/assets/images/sem618/customer.png" alt="" />
        <div>在线客服</div>
      </div>
      <a class="item" href="tel:0571-85785223">
        <img src="@/assets/images/sem618/phone.png" alt="" />
        <div>电话咨询</div>
      </a>
      <div class="item" @click="handleBackToTopClick">
        <img src="@/assets/images/sem618/backtop.png" alt="" />
        <div>返回顶部</div>
      </div>
    </div>
    <!-- 表单弹框 -->
    <CoverForm :show="showForm" @close="handleClose" @msg="handleShowMsg" @submitSuccess="handleDialogFormSuccess" />
    <!-- Form提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- Form 成功弹框 -->
    <SuccessForm v-if="showSuccessDialog" @closeform="showSuccessDialog = false" :isPcFlag="false" />
    <!-- 客户案例 -->
    <!-- <CustomerCase :dataList="customerCaseList" :isPcFlag="false"></CustomerCase> -->
    <!-- 底部 -->
    <Footer type="h5" />
  </div>
</template>

<script>
import '@/mixins/form/flexible'
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  mixins: [qiyuMixin],
  components: {
    ProductPower: () => import('@/views/extension/components/h5/ProductPower.vue'),
    Header: () => import('@/components/header/index.vue'),
    Banner: () => import('@/components/Banner.vue'),
    CoverForm: () => import('@/components/CoverForm.vue'),
    Footer: () => import('@/components/footer/index.vue'),
    Message: () => import('@/components/Message.vue'),
    SuccessForm: () => import('@/components/SuccessForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      message: {
        content: '',
        show: false,
      },
      // 成功的弹框
      showSuccessDialog: false,
      // 弹框
      showForm: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      h5BgImg: require('@/assets/images/sem618/h5_banner_bg.png'),
      equityData: dataList.equityData,
      productPower: dataList.productPower,
      flowPathOneLine: dataList.flowPathOneLine,
      flowPathTwoLine: dataList.flowPathTwoLine,
      safeReliableData: dataList.safeReliableData,
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
    }
  },
  mounted() {
    this.addQiyuScript()
  },
  computed: {
    RoutingJudgment() {
      return window.location.hostname === 'guangzhou.esign.cn'
    },
  },
  methods: {
    handleBackToTopClick() {
      window.scrollTo(0, 0)
    },
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },
    touchStart(event) {
      event.preventDefault() // 通知 Web 浏览器不要执行与事件关联的默认动作
    },
    showDialog() {
      this.showForm = true
      document.addEventListener('touchmove', this.touchStart, { passive: false })
    },
    handleClose() {
      this.showForm = false
      document.removeEventListener('touchmove', this.touchStart, { passive: false })
    },
    handleShowMsg({ content }) {
      this.message.content = content
      this.message.show = true
    },
    handleDialogFormSuccess() {
      this.handleClose()
      this.showSuccessDialog = true
    },
    // 在线咨询
    OnlineConsultationClick() {
      if (this.RoutingJudgment) {
        this.handleCustomerServiceBaiduClick({ templateId: 6641070 })
      } else {
        this.handleCustomerServiceClick({ entry: 'yinzhangsecordpage' })
      }
    },
  },
}
</script>
<style lang="less">
.con {
  min-width: auto;
}
.h5-sem618-banner {
  width: 100%;
  position: relative;
  padding-top: 1.3333rem;
  .con {
    .title {
      position: absolute;
      left: 2.4533rem;
      top: 1.9733rem;
    }
    .des {
      position: absolute;
      left: 3.3333rem;
      top: 4.08rem;
    }
    .btns {
      position: absolute;
      left: 3.4133rem;
      bottom: 0.6667rem;
    }
  }
}
.sem618-equity {
  width: 100%;
  background: #f7f8f9;
  box-shadow: 0px 2px 4px 0px #ffffff;
  text-align: center;
  padding-bottom: 0.7467rem;
  .title {
    font-size: 0.48rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.12rem;
    text-shadow: 0px 2px 4px #ffffff;
    padding: 0.9067rem 0 0.2133rem 0;
  }
  .desc {
    font-size: 0.3733rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.64rem;
    text-shadow: 0px 2px 4px #ffffff;
    margin-top: 0.2133rem;
  }
  .info {
    display: flex;
    justify-content: center;
    padding-top: 0.8rem;
    flex-flow: wrap;
    .item {
      width: 4.4267rem;
      height: 2.6933rem;
      background: linear-gradient(180deg, #fa7a6d 0%, #e63740 100%);
      border-radius: 0.16rem;
      margin-right: 0.16rem;
      margin-left: 0.16rem;
      margin-bottom: 0.3733rem;
      .sub-title {
        width: 100%;
        height: 0.7733rem;
        line-height: 0.7733rem;
        background: linear-gradient(270deg, #ffefd6 0%, #ffe0b9 100%);
        border-radius: 0.16rem 0.16rem 0px 0px;
        font-weight: 500;
        color: rgba(125, 69, 48, 0.85);
        font-size: 0.3733rem;
      }
      .msg {
        width: 100%;
        height: 1.92rem;
        line-height: 1.92rem;
        background: linear-gradient(180deg, #fa7a6d 0%, #e63740 100%);
        border-radius: 0.16rem;
        font-size: 0.3733rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        position: relative;
        .blod-msg {
          font-size: 0.48rem;
        }
        img {
          position: absolute;
          top: 24px;
          width: 2.1333rem;
          height: 2.1333rem;
          right: -56px;
        }
      }
    }
  }
}
.basisDisplay(@justify, @align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}

.columnDisplay(@justify, @align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// 无需邮寄，1分钟完成线上签署
.flow-path {
  .path-content {
    padding-top: 0.2667rem;
    .content {
      width: 100%;
      .basisDisplay(space-between, center);
      .path-left {
        width: 100%;
        .one-line,
        .three-line {
          .basisDisplay(space-around, center);
          .item {
            .basisDisplay(center, center);
            .item-content {
              margin-right: 40px;
              .columnDisplay(center, center);
              & > img {
                width: 0.8267rem;
                height: 0.8267rem;
              }
              & > p {
                font-size: 0.3733rem;
                color: rgba(0, 0, 0, 0.85);
                line-height: 0.5333rem;
              }
            }
          }
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
        }
        .two-line {
          .basisDisplay(flex-end, center);
          margin: 0.1867rem 0;
          .two-line-arrow {
            width: 0.2667rem;
            height: 0.2667rem;
            transform: rotate(90deg);
            margin-right: 100px;
          }
        }
        .three-line {
          .three-line-arrow {
            transform: scaleX(-1);
          }
        }
      }
    }
  }
}
// 安全可靠的电子签章服务
.safe-reliable {
  .content {
    .card {
      width: 100%;
      padding-bottom: 0.5333rem;

      position: relative;
      .title {
        font-size: 0.4267rem;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        position: absolute;
        top: 40px;
        margin-left: 0.4rem;
      }
      .desc {
        font-size: 0.32rem;
        color: rgba(0, 0, 0, 0.65);
        box-shadow: 2px 3px 5px 0px rgba(206, 217, 235, 0.5);
        padding: 0.2133rem 0.32rem 0.4rem 0.32rem;
        line-height: 0.5867rem;
      }
    }
  }
}
// 操作按钮样式
.btns-box {
  .basisDisplay(center, center);
  .btns {
    display: flex;

    & > div {
      width: 2.6667rem;
      height: 0.8rem;
      border-radius: 0.1067rem;
      font-size: 0.3733rem;
      margin: 0 0.24rem;
      cursor: pointer;
      .basisDisplay(center, center);
    }

    .mfsy {
      background: #e63740;
      color: #ffffff;
    }
    .mfsy:hover {
      background: #fb6169;
    }
    .zxzx {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
      color: #e63740;
    }
    .zxzx:hover {
      color: #fb6169;
    }
  }
}
.sales-hotline {
  height: 2.9333rem;
  background: #e63740;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;

  .title {
    font-weight: 500;
    color: #ffffff;
    line-height: 0.7467rem;
    font-size: 0.5333rem;
  }
  .zxzx {
    width: 2.6667rem;
    height: 0.8rem;
    border-radius: 0.1067rem;
    font-size: 0.3733rem;
    cursor: pointer;
    .basisDisplay(center, center);
    background: #ffffff;
    box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
    color: #e63740;
    margin-top: 0.3733rem;
  }
}
.footer-btns {
  height: 1.6rem;
  background: #ffffff;
  box-shadow: 0px -2px 6px 0px rgba(221, 221, 221, 0.5);
  display: flex;
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: row;
  z-index: 1;
  .item {
    width: 33.3%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    font-size: 0.3733rem;
    font-weight: 400;
    color: #272727;
  }
  img {
    width: 0.6667rem;
    height: 0.6667rem;
  }
}
</style>
